import { publicIpv4 } from 'public-ip';
import { API } from 'aws-amplify'
import { usersByIpAddress } from "../graphql/queries";
import { createUser } from "../graphql/mutations";

export function isProduction() {
  let branch = process.env.USER_BRANCH;
  if (!branch) {
    return false;
  }
  return branch === 'production';
}

export function isStaging() {
  let branch = process.env.USER_BRANCH;
  console.log('branch: ' + branch);
  if (!branch) {
    return true;
  }
  return branch === 'staging';
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export async function getUserId() {
  let userId = window.$userId;
  if (userId !== undefined && userId !== '') {
    return userId;
  }

  let ipAddress = window.$ipAddress;
  if (ipAddress === undefined || ipAddress === '') {
    ipAddress = await publicIpv4();
    window.$ipAddress = ipAddress;
  }

  let users = []
  try {
    users = await API.graphql({
      query: usersByIpAddress,
      variables: { 'ipAddress': ipAddress }
    })
  } catch (err) {
    console.error("Error Message: ", err) 
    return null;
  };
  
  if (users.data.UsersByIpAddress.items.length > 0) {
    userId = users.data.UsersByIpAddress.items[0].id;
  } else {
    const userDetails = {
      ipAddress: ipAddress
    }; 
    let newUser = null;
    try {
      newUser = await API.graphql({ 
        query: createUser, 
        variables: { input: userDetails }
      });
    } catch (err) {
      console.error("Error Message: ", err) 
      return null;
    };
    userId = newUser.data.createUser.id;
  }
  
  window.$userId = userId;
  return userId;
}